import ormaApi from './OrmaApi';

export async function sendSMS(msgTo, msgBody) {
    await ormaApi.post('/api/sms/send', {
        msgTo,
        msgBody
    });
}